import { Tooltip } from '@mantine/core'

export interface ContactUsageBadgeProps {
  /** True when this is the contact point outreach would actually use. */
  isUsed: boolean
  /** What it is used for, as it reads on screen — "Used for email". */
  label: string
  /** The longer explanation, shown on hover. */
  explanation: string
}

/**
 * Marks the one contact point a verification would actually go to.
 *
 * Only the row that gets used is marked. A number on every row would say how
 * the list is ordered, which the order already says; what is worth calling out
 * is the row that decides where the next verification goes.
 */
const ContactUsageBadge = ({
  isUsed,
  label,
  explanation,
}: ContactUsageBadgeProps) => {
  if (!isUsed) return null

  return (
    <Tooltip
      label={explanation}
      withArrow
      multiline
      w={260}
      events={{ hover: true, focus: false, touch: true }}
    >
      {/*
        A plain span, not a focusable element: the label is already visible
        text, so the tooltip only elaborates. Making it focusable would add two
        dead tab stops per row for something a keyboard user can already read.
      */}
      <span className="inline-flex flex-none items-center rounded bg-doubleNickel-brand-50 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-doubleNickel-brand-700">
        {label}
      </span>
    </Tooltip>
  )
}

export default ContactUsageBadge
